import React from 'react';

import { useSelector } from 'react-redux';

import { useMutation } from '@tanstack/react-query';
import PropTypes from 'prop-types';

import { Text } from '@asteria/component-core/typography';

import { Switch } from '@asteria/component-form-v2';

import * as AppStore from '@asteria/datalayer/stores/app';

import { Translation } from '@asteria/language';
import { cn } from '@asteria/utils-funcs/classes';

import { useCompanyVersion } from '../../CompanyVersion';

import './styles.scss';

/**
 * @type { React.FC<{ className: string, onAction: (action: string, data?: unknown) => Promise<void> }> }
 */
const AutoSendSwitch = React.memo(function AutoSendSwitch(props) {
	const { className, onAction } = props;

	const version = useCompanyVersion();

	const company = useSelector((store) => AppStore.selectors.company(store));

	const toggleAutoSend = useMutation({
		mutationFn: async () =>
			onAction?.('service:settings:save', {
				serviceId: company?.service?.id,
				service: {
					data: { autoSend: !company?.service?.data?.autoSend },
				},
			}),
	});

	if (version < 3) {
		return null;
	}

	return (
		<div className={cn('asteria-component__auto-send-toggle', className)}>
			<Switch
				label={{
					position: 'left',
					label: (
						<Translation
							translationKey={['invoices.import.auto.toggle']}
							Component={Text}
							size="sm"
						/>
					),
				}}
				onClick={toggleAutoSend.mutateAsync}
				active={company?.service?.data?.autoSend}
				uncontrolled
			/>
		</div>
	);
});

AutoSendSwitch.propTypes = {
	className: PropTypes.string,
	onAction: PropTypes.func,
};

export default AutoSendSwitch;
